import { Component, OnInit } from '@angular/core';
import { OrderStateService } from '../../../order/services/order-state.service';
import { Order } from '../../../order/models/order';
import { GiftCardStepService } from '../../services/giftcard-step.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { Partner } from '../../../partner/models/partner';

@Component({
  selector: 'app-giftcard-order',
  templateUrl: './giftcard-order.component.html',
  styleUrls: ['./giftcard-order.component.css']
})
export class GiftCardOrderComponent implements OnInit {

  order: Order;

  constructor(
    private orderStateService: OrderStateService,
    private giftCardStepService: GiftCardStepService,
    private shopSettingsService: ShopSettingsService,
    private partnerStateService: PartnerStateService,
  ) { }

  ngOnInit(): void {
    this.order = this.orderStateService.order;
  }

  onNext(): void {
    this.giftCardStepService.forward();
  }

  onBack(): void {
    this.giftCardStepService.back();
  }

  get isVuPayment(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  get isShowProductImages(): boolean {
    return this.shopSettingsService.shopSettings.isShowProductImages;
  }

}
